import './ReloadPrompt.css'
import toast from 'react-hot-toast'

// @ts-ignore — virtual module provided by vite-plugin-pwa
import { useRegisterSW } from 'virtual:pwa-register/react'

function ReloadPrompt() {
    const {
        offlineReady: [offlineReady],
        needRefresh: [needRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegisterError(error: any) {
            console.error('SW registration error', error)
        },
    })

    const doUpdate = async () => {
        void caches.keys().then(cacheNames => {
            cacheNames.forEach(cacheName => {
                void caches.delete(cacheName)
            })
        })
        await updateServiceWorker(true)
    }

    if (offlineReady) {
        toast.success('Gibi app updated')
    }

    return offlineReady ? null : (
        <div className="ReloadPrompt-container">
            {needRefresh && (
                <div className="ReloadPrompt-toast">
                    <div className="ReloadPrompt-message">
                        <span>Gibi app update available, click on reload button to install.</span>
                    </div>
                    <button className="ReloadPrompt-toast-button" onClick={() => doUpdate()}>Reload</button>
                </div>
            )}
        </div>
    )
}

export default ReloadPrompt
